const BodyPartsLeft = {
    LeftForefoot: "forefoot_left",
};
const BodyPartsRight = {
    RightForefoot: "forefoot_right",
};
const BodyPartsFrontMiddle = {
    Epigastric: "front_epigastric",
    Mouth: "front_mouth",
    Nose: "front_nose",
    Pelvis: "front_pelvis",
    Pubis: "front_pubis",
    UpperSternum: "front_upper_sternum",
    LowerSternum: "front_lower_sternum",
    Umbilical: "front_umbilical",
};
const BodyPartsFrontLeft = {
    LeftAnkle: "front_ankle_left",
    LeftArm: "front_arm_left",
    LeftCrotch: "front_crotch_left",
    LeftEar: "front_ear_left",
    LeftElbow: "front_elbow_left",
    LeftEye: "front_eye_left",
    LeftFace: "front_face_left",
    LeftForearm: "front_forearm_left",
    LeftHand: "front_hand_left",
    LeftKnee: "front_knee_left",
    LeftLeg: "front_leg_left",
    LeftLumbar: "front_lumbar_left",
    LeftNeck: "front_neck_left",
    LeftRibs: "front_ribs_left",
    LeftShoulder: "front_shoulder_left",
    LeftUpperSkull: "front_upper_skull_left",
    LeftThigh: "front_thigh_left",
    LeftWrist: "front_wrist_left",
};
const BodyPartsFrontRight = {
    RightAnkle: "front_ankle_right",
    RightArm: "front_arm_right",
    RightCrotch: "front_crotch_right",
    RightEar: "front_ear_right",
    RightElbow: "front_elbow_right",
    RightEye: "front_eye_right",
    RightFace: "front_face_right",
    RightForearm: "front_forearm_right",
    RightHand: "front_hand_right",
    RightKnee: "front_knee_right",
    RightLeg: "front_leg_right",
    RightLumbar: "front_lumbar_right",
    RightNeck: "front_neck_right",
    RightRibs: "front_ribs_right",
    RightShoulder: "front_shoulder_right",
    RightUpperSkull: "front_upper_skull_right",
    RightThigh: "front_thigh_right",
    RightWrist: "front_wrist_right",
};
const BodyPartsBackMiddle = {
    Cervical: "back_cervical",
    UpperSpinalLumbar: "back_upper_spinal_lumbar",
    LowerSpinalLumbar: "back_lower_spinal_lumbar",
    UpperSpinalThoracic: "back_upper_spinal_thoracic",
    LowerSpinalThoracic: "back_lower_spinal_thoracic",
    Sacrum: "back_sacrum",
};
const BodyPartsBackLeft = {
    LeftAchilles: "back_achilles_left",
    LeftAnkle: "back_ankle_left",
    LeftArm: "back_arm_left",
    LeftButtock: "back_buttock_left",
    LeftCalf: "back_calf_left",
    LeftElbow: "back_elbow_left",
    LeftLumbar: "back_lumbar_left",
    LeftForearm: "back_forearm_left",
    LeftHamstring: "back_hamstring_left",
    LeftHand: "back_hand_left",
    LeftKnee: "back_knee_left",
    LeftNeck: "back_neck_left",
    LeftShoulder: "back_shoulder_left",
    LeftUpperSkull: "back_upper_skull_left",
    LeftLowerSkull: "back_lower_skull_left",
    LeftThoracic: "back_thoracic_left",
    LeftWrist: "back_wrist_left",
};
const BodyPartsBackRight = {
    RightAchilles: "back_achilles_right",
    RightAnkle: "back_ankle_right",
    RightArm: "back_arm_right",
    RightButtock: "back_buttock_right",
    RightCalf: "back_calf_right",
    RightElbow: "back_elbow_right",
    RightLumbar: "back_lumbar_right",
    RightForearm: "back_forearm_right",
    RightHamstring: "back_hamstring_right",
    RightHand: "back_hand_right",
    RightKnee: "back_knee_right",
    RightNeck: "back_neck_right",
    RightShoulder: "back_shoulder_right",
    RightUpperSkull: "back_upper_skull_right",
    RightLowerSkull: "back_lower_skull_right",
    RightThoracic: "back_thoracic_right",
    RightWrist: "back_wrist_right",
};
export const BodyPartsBack = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, BodyPartsLeft), BodyPartsRight), BodyPartsBackMiddle), BodyPartsBackLeft), BodyPartsBackRight);
export const BodyPartsFront = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, BodyPartsLeft), BodyPartsRight), BodyPartsFrontMiddle), BodyPartsFrontLeft), BodyPartsFrontRight);
//# sourceMappingURL=bodyParts.js.map